<template>
    <v-snackbar
      v-model="snackbarPropLocal"
      color="grey-lighten-5"
      :timeout="-1"
      rounded="lg"
      elevation="24"
      class="text-justify"
      :location="mobile ? 'center bottom' : 'center right bottom'"
      :vertical="true"
      multi-line
    >
    <v-container fluid>
        <div :class="mobile ? 'font-weight-bold text-body-3' : 'font-weight-bold text-justify text-body-1'">
            <span class="text-primary">{{$t('cookies.presentation')}}</span>
        </div>
        
        <Transition name="bounce">
            <v-container v-if="showOptions">
                <v-divider class="mt-2"></v-divider>
                <v-switch
                    v-model="cookie.necessary"
                    :label="$t('cookies.necessary_label')"
                    readonly
                    color="accent"
                ></v-switch>
                    {{$t('cookies.necessary')}}
                <v-switch
                    v-model="cookie.statistics"
                    :label="$t('cookies.statistics_label')"
                    color="accent"
                ></v-switch>
                    {{$t('cookies.statistics')}}
            </v-container>
        </Transition>
    </v-container>

        <v-divider></v-divider>
        <template v-slot:actions>
            <div class="text-center">
                <v-btn
                    color="accent"
                    variant="outlined"
                    @click="$emit('cookie-reject')"                
                    class="mt-2 font-weight-bold mb-4 white--text">
                    <v-icon class="mr-3">mdi-alert-circle</v-icon>
                    {{$t('cookies.discord')}}
                </v-btn>
                <v-btn
                    color="warning"
                    variant="outlined"
                    @click="showOptions = !showOptions"
                    class="mt-2 mx-4 font-weight-bold mb-4 white--text">
                    <v-icon class="mr-3">mdi-cog</v-icon>
                    {{$t('cookies.options')}}
                </v-btn>
                <v-btn
                    class="mt-2 greener--text font-weight-bold mb-4 white--text"
                    color="primary" 
                    variant="outlined"
                    elevation="2"
                    @click="$emit('cookie-accept', cookie)"
                >
                    <v-icon class="mr-3">mdi-cookie</v-icon>
                    {{$t('cookies.agree')}}
                </v-btn>
            </div>
        </template>
    </v-snackbar>
</template>
<script>
export default{
    watch:{
        snackbarProp:{
            immediate: true,
            handler(val){
                this.snackbarPropLocal = val
            }
        }
    },
    beforeMount(){
        this.checkMobile()
    },
    mounted(){
        window.addEventListener('resize', this.handleResize);
        this.snackbarPropLocal = this.snackbarProp
    },
    props:{
        snackbarProp: Boolean
    },
    data(){
        return{
            snackbarPropLocal: null,
            mobile: false,
            showOptions: false,
            cookie:{
                necessary: true,
                statistics: true
            }
        }
    },
    methods: {
        handleResize() {
            this.checkMobile()
        },
        checkMobile(){
            if(screen.width <= 760)
                this.mobile = true
            else
                this.mobile = false
        }
    }
}
</script>
<style>
@media(max-width: 850px){
    .v-snack__action {
        width: 100% !important;
        margin: auto !important; 
        display: block !important;
    }
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
</style>